// One place that turns a typed API error into the right shared state.
import { ApiError } from "@/lib/api";
import { ErrorState, NotFound, PermissionDenied, SessionExpired } from "@/components/states";

export function QueryError({
  error,
  onRetry,
  title,
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}) {
  if (error instanceof ApiError) {
    if (error.kind === "permission-denied") return <PermissionDenied />;
    if (error.kind === "session-expired") return <SessionExpired />;
    if (error.kind === "not-found") return <NotFound />;
  }
  return <ErrorState title={title} error={error} onRetry={onRetry} />;
}
